export const confirmActionsContainerStyles = {
  display: 'flex',
  gap: '8px',
};

export const confirmActionsButtonStyles = {
  height: '22px',
  minHeight: '22px',
  padding: '1px 8px',
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
};
